/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-11.
 */
import React, { Component } from 'react';
import { findSelectedIndex } from '../../common/helpers';
import { COINS } from '../../data/selects';
import { PRE_INVOICE_TYPES } from './definitions';
import { Select } from '../../components/data-containers';

class Header extends Component {
    render() {
        const { customerName, preInvoiceType, onPreInvoiceTypeChange, onCoinChange, coin } = this.props;
        return (
            <div className="row prefactura-header">
                <div className="col-md-12">
                    <div className="col-md-3">
                        <h3 className="text-bold text-color-light">{customerName}</h3>
                    </div>
                    <div className="col-md-5">
                        <p className="text-bold text-color-light">Tipos de Factura</p>
                        <Select
                            value={preInvoiceType}
                            options={PRE_INVOICE_TYPES}
                            notify={(value) => {
                                const billConfig = PRE_INVOICE_TYPES[findSelectedIndex(PRE_INVOICE_TYPES, value)];
                                onPreInvoiceTypeChange(value, billConfig);
                            }}
                        />
                    </div>
                    <div className="col-md-4">
                        <p className="text-bold text-color-light">Moneda</p>
                        <Select
                            value={coin}
                            options={COINS}
                            notify={(value) => onCoinChange(value)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./forms/customPrefactura/header.js